import { render, staticRenderFns } from "./GroupMemberOverview.vue?vue&type=template&id=572b9432&scoped=true&"
import script from "./GroupMemberOverview.vue?vue&type=script&lang=js&"
export * from "./GroupMemberOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberOverview.vue?vue&type=style&index=0&id=572b9432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b9432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VDialog,VIcon,VSpacer})
